$(document).ready(function() {
	var lang = $('html').attr('lang');

	/**
	 * Gestion resize + scroll
	 */
	// Resize de la fenêtre
	resize_window();
	$(window).resize(function() {
		resize_window();
	});

	// Gestion du scroll
	$(window).scroll(function() {

	});

	// Shifter
	if ($('body').hasClass('extranet')) {
		$.shifter({
			maxWidth: '4000px'
		});
	} else {
		$.shifter({
			maxWidth: '1320px'
		});
	}

	// WOW
	new WOW().init();

	// Lazyload
	lazyload();

	// Rollover Mon compte
	$('.top_barre_account_detail form input').focusin(function() {
		$('.top_barre_account').addClass('active');
	});
	$('.top_barre_account_detail form input').focusout(function() {
		$('.top_barre_account').removeClass('active');
	});

	// Datepicker
	$('.date-picker').datepicker({
		language: lang,
		autoclose: true
	});

	// Formulaires
	if ($('.form_common').length > 0) {
		$('.form_common').each(function() {
			var form = $(this);
			form.find('input, select, textarea').each(function() {
				var field = $(this);
				field.on('focus', function() {
					field.addClass('validation');
				});
			});
		});
	}

	$('.pageinfos select').on('change', function() {
		$(this).parents('form').submit();
	});

	// Accordéon
	if ($('.accordeon_toggle').length > 0) {
		$('.accordeon_toggle').on('click', function(e) {
			e.preventDefault();

			var link = $(this);
			var content = $(link.attr('href'));

			if (!link.hasClass('active')) {
				$('.accordeon_toggle').removeClass('active');
				link.addClass('active');
				$('.accordeon_content:visible').slideUp(800);
				content.slideDown(800);
			}
		});

		if (window.location.hash != '' && $('.accordeon_toggle[href="' + window.location.hash + '"]').length > 0) {
			$('.accordeon_toggle[href="' + window.location.hash + '"]').trigger('click');
		} else {
			$('.accordeon_toggle').first().trigger('click');
		}
	}

	// Initialisation CKEditor Simple
	if ($('.ckeditorSimple').length > 0) {
		$('.ckeditorSimple').each(function() {
			CKEDITOR.replace($(this).attr('name'), {
				customConfig: site_config_path + '/ckeditor/ckeditor_simple.js',
				language: lang,
				height: 240
			});
		});
	}

	// Initialisation CKEditor Normal
	if ($('.ckeditorNormal').length > 0) {
		$('.ckeditorNormal').each(function() {
			CKEDITOR.replace($(this).attr('name'), {
				customConfig: site_config_path + '/ckeditor/ckeditor_normal.js',
				language: lang,
				height: 240,
				allowedContent: true
			});
		});
	}

	// Initialisation CKEditor Full
	if ($('.ckeditorComplet').length > 0) {
		$('.ckeditorComplet').each(function() {
			CKEDITOR.replace($(this).attr('name'), {
				customConfig: site_config_path + '/ckeditor/ckeditor_complet.js',
				language: lang,
				height: 480,
				allowedContent: true
			});
		});
	}

	// jQuery Confirm
	$('.btn-delete').on('click', function(e) {
		e.preventDefault();

		var link = $(this).attr('href');

		$.confirm({
			title: 'Attention !',
			content: 'Cette action est irréversible !',
			theme: 'modern',
			type: 'blue',
			icon: 'fa fa-exclamation-triangle',
			useBootstrap: false,
			buttons: {
				confirm: {
					text: 'OK',
					btnClass: 'btn-blue',
					action: function () {
						window.location.href = link;
					},
				},
				cancel: {
					text: 'Annuler',
					action: function () {

					}
				}
			}
		});
	});

	// Rate it
	if ($('.rateit').length > 0) {
		$('.rateit').on('click', function() {
			var rateit = $(this);
			var rateit_users_id = rateit.data('usersid');
			var rateit_produits_id = rateit.data('produitsid');
			var rateit_note = rateit.rateit('value');

			$.ajax({
				type	: "POST",
				url		: lang_path+"/produits/rateit/index.html",
				data	: 'users_id=' + rateit_users_id + '&produits_id=' + rateit_produits_id + '&note=' + rateit_note,
				error	: function(msg) {
					alert(msg);
				},
				success	: function(data) {
					rateit.rateit('readonly', true);
				}
			});
		});
	}

	if ($('.bandeau_carrousel').length > 0) {
		var carrousel_bandeau = $('.bandeau_carrousel').owlCarousel({
			loop: true,
			items: 1,
			margin: 0,
			lazyLoad: true,
			autoplay: true,
			autoplayTimeout: 5000,
			autoplayHoverPause: false,
			animateIn: 'fadeIn',
			animateOut: 'fadeOut'
		});
	}

	$('.filtre_toggle').on('click', function(e) {
		$(this).parents('.filtre').siblings().removeClass('active');
		$(this).parents('.filtre').toggleClass('active');
	});

	$('.filtre_detail_onglet').on('click', function(e) {
		if (!$(this).hasClass('active')) {
			$('.filtre_detail_onglet').removeClass('active');
			$(this).addClass('active');
			$('.sousfiltre').hide();
			$($(this).attr('rel')).show();
		}
	});
	$('.filtre_detail_onglet').first().trigger('click');

	$('.filtre_delete').on('click', function() {
		if ($(this).attr('rel').includes('|')) {
			$(this).attr('rel').split('|').forEach(function(item) {
				$('[name="' + item + '"]').val('');
				$('[name="' + item + '"]').removeAttr('checked');
				$('[name="' + item + '"] option').removeAttr('selected');
			});
		} else {
			$('[name="' + $(this).attr('rel') + '"]').val('');
			$('[name="' + $(this).attr('rel') + '"]').removeAttr('checked');
			$('[name="' + $(this).attr('rel') + '"] option').removeAttr('selected');
		}
		$('#form_filtres').submit();
	});
});

function resize_window() {

}
